<template>
  <Form ref="maintenanceForm" :model="maintenance" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="maintenance.id" type="hidden"/>

    <FormItem  :label="this.$t('property.maintenance.maintenanceType.label')" prop="maintenanceType">
      <Select v-model="maintenance.maintenanceType" :placeholder="$t('property.maintenance.maintenanceType.holder')" filterable>
        <Option v-for="item in this.dict.deviceType" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('property.maintenance.maintenanceTime.label')" prop="maintenanceTime">
      <Date-picker :value="maintenance.maintenanceTime" type="datetime" @on-change="setTimeFormat"
                   :placeholder="this.$t('property.maintenance.maintenanceTime.holder')"></Date-picker>
    </FormItem>

    <FormItem  :label="this.$t('property.maintenance.maintenancePeople.label')" prop="maintenancePeople">
      <Select v-model="maintenance.maintenancePeople" filterable placeholder="请选择维修人">
        <Option  v-for="item in model11" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
      <!--<InputNumber v-model="maintenance.maintenancePeople" :placeholder="$t('property.maintenance.maintenancePeople.holder')"/>-->
    </FormItem>

    <FormItem  :label="this.$t('property.maintenance.maintenanceContent.label')" prop="maintenanceContent">
      <Input v-model="maintenance.maintenanceContent" :placeholder="$t('property.maintenance.maintenanceContent.holder')"  type="textarea" :rows="3"/>
    </FormItem>

    <FormItem  :label="this.$t('property.maintenance.maintenanceMoney.label')" prop="maintenanceMoney">
      <Input v-model="maintenance.maintenanceMoney" :placeholder="$t('property.maintenance.maintenanceMoney.holder')"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  dictParams: ['deviceType'],
  data () {
    return {
      model11:[],
      maintenance: {
        id: null,
        maintenanceType: null,
        maintenanceTime: null,
        maintenancePeople: null,
        maintenanceContent: null,
        maintenanceMoney: null
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handlePeopleList(){
      this.loading = true;
      api.property.Employees.listEmployeesInfo()
        .then(data=>{
          this.model11 = data;
          //this.employees.jobId = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    setTimeFormat(str, date){
      console.log(str)
      var datetime =  new Date(str);
      this.maintenance.maintenanceTime = str;
      console.log(this.trim);
      // console.log(datetime);
    },
    handleSubmit(then,error){
      this.$refs['maintenanceForm'].validate(valid => {
        if (valid) {
          if (this.maintenance.id) {
            this.updateMaintenance(this.maintenance).then(then).error(error)
          } else {
            this.createMaintenance(this.maintenance).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.maintenance.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['maintenanceForm'].resetFields());
      this.handlePeopleList();
    },
    getMaintenance(id,type){
      this.loading = true;
      this.$refs['maintenanceForm'].resetFields()
      api.property.Maintenance.detail(id).then(data => {
        this.maintenance = data;
        this.handlePeopleList();
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createMaintenance(maintenance){
      this.loading = true;
      return api.property.Maintenance.add(maintenance)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateMaintenance(maintenance){
      this.loading = true;
      return api.property.Maintenance.update(maintenance)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      maintenanceType: [{type: 'number', required: true, message: this.$t('property.maintenance.maintenanceType.required'),trigger: 'blur'}],
      //maintenanceTime: [{type: 'date', required: true, message: this.$t('property.maintenance.maintenanceTime.required'),trigger: 'blur'}],
      maintenancePeople: [{type: 'number', required: true, message: this.$t('property.maintenance.maintenancePeople.required'),trigger: 'blur'}],
      maintenanceContent: [{type: 'string',max: 65535, message: this.$t('property.maintenance.maintenanceContent.max'),trigger: 'blur'}],
      maintenanceMoney: [{type: 'string', required: true, message: this.$t('property.maintenance.maintenanceMoney.required'),trigger: 'blur'}, {type: 'string',max: 20, message: this.$t('property.maintenance.maintenanceMoney.max'),trigger: 'blur'}],
      createTime: [{type: 'date', required: true, message: this.$t('property.maintenance.createTime.required'),trigger: 'blur'}],
      updateTime: [{type: 'date', required: true, message: this.$t('property.maintenance.updateTime.required'),trigger: 'blur'}],
      isDelete: [{type: 'number', required: true, message: this.$t('property.maintenance.isDelete.required'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['maintenanceForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
